var map = {
	"./subdir/tmpl": 12,
	"./tmpl": 10
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3;



/*****************
 ** WEBPACK FOOTER
 ** ./parsing/context/templates ^\.\/.*l$
 ** module id = 3
 ** module chunks = 0
 **/